import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const userLoginInfoResult = await fetch(
      `${URI_TARIFF_PLAN}payment/set/`,
      opts,
    );
    const resultJson = await userLoginInfoResult.json();

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson);
    }

    return resultJson;
  } catch (error) {
    return Promise.reject(error);
  }
};
